import { render, staticRenderFns } from "./multi-router-link.vue?vue&type=template&id=5913b84d&"
import script from "./multi-router-link.vue?vue&type=script&lang=ts&"
export * from "./multi-router-link.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports